import request from '../utils/request';
// import QS from 'qs'

export default {
  //登录
  login: query => {
    return request({
      url: 'system/account/getToken',
      method: 'post',
      data: query,
    });
  },
  //获取图片验证码
  GetCode: query => {
    return request({
      url: 'system/account/getCode',
      method: 'get',
      params: query,
    });
  },
  //获取登录二维码
  loginQrcode: query => {
    return request({
      url: 'system/account/getLoginQrCode',
      method: 'get',
      params: query,
    });
  },
  //扫码登录状态检查
  loginCheck: query => {
    return request({
      url: 'system/account/checkQrCode',
      method: 'post',
      data: query,
    });
  },

  //退出
  logOut: query => {
    return request({
      url: 'system/account/logOunt',
      method: 'post',
      data: query,
    });
  }, //退出
  changePwd: query => {
    return request({
      url: 'system/account/changePwd',
      method: 'post',
      data: query,
    });
  },

  //权限菜单
  getAuthMenu: query => {
    return request({
      url: 'system/menu/getAuthMenu',
      method: 'get',
      params: query,
    });
  },

  //获取区域信息
  getArea: query => {
    return request({
      url: 'system/getarea',
      method: 'post',
      data: query,
    });
  },

  // 用户管理
  userList: query => {
    return request({
      url: '/system/user/list',
      method: 'get',
      params: query,
    });
  },

  // 短信列表
  sendList: query => {
    return request({
      url: 'system/sms/getAlreadySendList',
      method: 'get',
      params: query,
    });
  },

  // 角色管理-列表
  accountRole: query => {
    return request({
      url: '/system/accountRole/getList',
      method: 'get',
      params: query,
    });
  },

  // 角色管理-添加
  roleAdd: query => {
    return request({
      url: 'system/accountRole/add',
      method: 'post',
      data: query,
    });
  },

  // 角色管理-删除
  roleDel: query => {
    return request({
      url: 'system/accountRole/del',
      method: 'post',
      data: query,
    });
  },

  // 角色管理-编辑
  roleUpdate: query => {
    return request({
      url: 'system/accountRole/update',
      method: 'post',
      data: query,
    });
  },

  // 角色管理-权限列表
  authList: query => {
    return request({
      url: 'system/menu/getSetAuthList',
      method: 'post',
      data: query,
    });
  },

  // 角色管理-权限列表-修改
  saveRoleAuth: query => {
    return request({
      url: 'system/accountRole/saveRoleAuth',
      method: 'post',
      data: query,
    });
  },

  // 账号管理-列表
  accountList: query => {
    return request({
      url: 'system/account/getList',
      method: 'get',
      params: query,
    });
  },

  // 账号管理-新增
  accountAdd: query => {
    return request({
      url: 'system/account/add',
      method: 'post',
      data: query,
    });
  },

  // 角色管理-获取绑定二维码
  accountGetBindQrCode: query => {
    return request({
      url: 'system/account/getBindQrCode',
      method: 'get',
      params: query,
    });
  },
  // 角色管理-获取绑定二维码
  accountUnBind: query => {
    return request({
      url: 'system/account/unBind',
      method: 'post',
      data: query,
    });
  },
  // 账号管理-编辑
  accountUpdate: query => {
    return request({
      url: 'system/account/update',
      method: 'post',
      data: query,
    });
  },

  // 账号管理-删除
  accountStatus: query => {
    return request({
      url: 'system/account/status',
      method: 'post',
      data: query,
    });
  },
  // 账号管理-删除
  accountDel: query => {
    return request({
      url: 'system/account/del',
      method: 'post',
      data: query,
    });
  },

  // 获取微信配置
  wechatSet: query => {
    return request({
      url: 'system/wechat/getSet',
      method: 'get',
      params: query,
    });
  },

  // 保存公众号接口
  wechatSave: query => {
    return request({
      url: 'system/wechat/saveSet',
      method: 'post',
      data: query,
    });
  },

  // 保存公众号配置
  wechatSaveSet: query => {
    return request({
      url: 'system/wechat/saveWechat',
      method: 'post',
      data: query,
    });
  },
  // 保存公众号配置
  baseSaveSet: query => {
    return request({
      url: 'system/config/saveBaseConfig',
      method: 'post',
      data: query,
    });
  },

  // 绑定公众号接口
  wechatBind: query => {
    return request({
      url: 'system/wechat/bindWechat',
      method: 'post',
      data: query,
    });
  },

  // 解绑公众号接口
  wechatUnBind: query => {
    return request({
      url: 'system/wechat/unBindWechat',
      method: 'post',
      data: query,
    });
  },

  // 保存微信支付配置
  WxPaySave: query => {
    return request({
      url: 'system/wechat/saveWxPay',
      method: 'post',
      data: query,
    });
  },

  // 获取微信菜单列表
  getWxMenu: query => {
    return request({
      url: 'system/wechat/getWxMenu',
      method: 'get',
      params: query,
    });
  },

  // 新增微信菜单
  addMenu: query => {
    return request({
      url: 'system/wechat/addMenu',
      method: 'post',
      data: query,
    });
  },

  // 编辑微信菜单
  updateMenu: query => {
    return request({
      url: 'system/wechat/updateMenu',
      method: 'post',
      data: query,
    });
  },

  // 获取内部链接列表
  getLinkList: query => {
    return request({
      url: 'system/link/getLinkList',
      method: 'get',
      params: query,
    });
  },

  // 删除微信菜单
  delMenu: query => {
    return request({
      url: 'system/wechat/delMenu',
      method: 'post',
      data: query,
    });
  },

  // 发布微信菜单
  syncMenu: query => {
    return request({
      url: 'system/wechat/syncMenu',
      method: 'get',
      params: query,
    });
  },

  // 获取微信模板消息
  getTemp: query => {
    return request({
      url: 'system/WxTemplate/getTemp',
      method: 'get',
      params: query,
    });
  },

  // 编辑微信模板消息
  updateTemp: query => {
    return request({
      url: 'system/WxTemplate/updateTemp',
      method: 'post',
      data: query,
    });
  },

  // 申请微信模板
  applyTemp: query => {
    return request({
      url: 'system/WxTemplate/applyTemp',
      method: 'post',
      data: query,
    });
  },

  // 获取短信模板列表
  getTemplateList: query => {
    return request({
      url: 'system/sms/getTemplateList',
      method: 'get',
      params: query,
    });
  },

  // 获取短信配置
  smsConfig: query => {
    return request({
      url: 'system/sms/getConfig',
      method: 'get',
      params: query,
    });
  },

  // 保存短信配置
  smsSaveConfig: query => {
    return request({
      url: 'system/sms/saveConfig',
      method: 'post',
      data: query,
    });
  },

  // 编辑短信模板配置
  editTemplate: query => {
    return request({
      url: 'system/sms/editTemplate',
      method: 'post',
      data: query,
    });
  },

  // 改变短信模板状态
  smsEditStatus: query => {
    return request({
      url: 'system/sms/editStatus',
      method: 'post',
      data: query,
    });
  },

  // 获取我的应用
  myAppList: query => {
    return request({
      url: '/system/app/mylist',
      method: 'get',
      params: query,
    });
  },

  // 获取应用列表
  getAppList: query => {
    return request({
      url: '/system/app/allList',
      method: 'get',
      params: query,
    });
  },

  // 更新应用列表
  updateMyList: query => {
    return request({
      url: '/system/app/updateapp',
      method: 'post',
      data: query,
    });
  },

  // 获取反馈列表
  feedbackList: query => {
    return request({
      url: '/system/feedback/list',
      method: 'get',
      params: query,
    });
  },

  // 获取反馈列表
  feedbackDetails: query => {
    return request({
      url: '/system/feedback/details',
      method: 'get',
      params: query,
    });
  },

  // 反馈确认解决关闭
  feedbackHandle: query => {
    return request({
      url: '/system/feedback/handle',
      method: 'post',
      data: query,
    });
  },

  // 获取协议列表
  agreementList: query => {
    return request({
      url: '/system/agreement/list',
      method: 'get',
      params: query,
    });
  },

  // 获取协议类型
  agreementTypes: query => {
    return request({
      url: '/system/agreement/types',
      method: 'get',
      params: query,
    });
  },

  // 保存协议
  agreementSaveData: query => {
    return request({
      url: '/system/agreement/saveData',
      method: 'post',
      data: query,
    });
  },

  // 删除协议
  agreementDel: query => {
    return request({
      url: '/system/agreement/del',
      method: 'post',
      data: query,
    });
  },

  // 获取腾讯地图配置
  getMapConfig: query => {
    return request({
      url: 'system/config/getConfig',
      method: 'get',
      data: query,
    });
  },
  saveMapConfig: query => {
    return request({
      url: 'system/config/saveMapConfig',
      method: 'post',
      data: query,
    });
  },

  //实名认证相关接口
  // 获实名配置信息
  getRealnameConfig: query => {
    return request({
      url: 'system/realname/getConfig',
      method: 'get',
      data: query,
    });
  },
  // 获实名配置信息
  saveRealnameConfig: query => {
    return request({
      url: 'system/realname/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 获实名配置信息
  realnameLog: query => {
    return request({
      url: 'system/realname/log',
      method: 'get',
      params: query,
    });
  },

  // 保存小程序配置
  saveMiniConfig: query => {
    return request({
      url: 'system/wechat/saveMiniConfig',
      method: 'post',
      data: query,
    });
  },

  // 消息模板列表
  getSceneList: query => {
    return request({
      url: 'system/scene/list',
      method: 'get',
      params: query,
    });
  },

  // 保存消息配置
  sceneSaveConfig: query => {
    return request({
      url: 'system/scene/saveConfig',
      method: 'post',
      data: query,
    });
  },
  //获取业务场景
  sceneList: query => {
    return request({
      url: 'system/scene/sceneList',
      method: 'get',
      params: query,
    });
  },

  // 获取微信消息列表
  getTempLogList: query => {
    return request({
      url: 'system/WxTemplate/getTempLogList',
      method: 'get',
      params: query,
    });
  },

  // 获取模板列表
  decorateGetList: query => {
    return request({
      url: 'system/decorate/getList',
      method: 'get',
      params: query,
    });
  },

  // 保存模板
  decorateSave: query => {
    return request({
      url: '/system/decorate/save',
      method: 'post',
      data: query,
    });
  },

  // 删除模板
  decorateDel: query => {
    return request({
      url: '/system/decorate/del',
      method: 'post',
      data: query,
    });
  },

  //设为首页
  decorateSetIndex: query => {
    return request({
      url: '/system/decorate/setIndex',
      method: 'post',
      data: query,
    });
  },

  // 获取模板详情
  decorateGetDetail: query => {
    return request({
      url: '/system/decorate/getDetail',
      method: 'get',
      params: query,
    });
  },

  // 根据选项类型查询出列表链接
  getLinkItem: query => {
    return request({
      url: '/system/link/getLinkItem',
      method: 'get',
      params: query,
    });
  },

  // 获取客服列表
  customerList: query => {
    return request({
      url: '/system/customer/list',
      method: 'get',
      params: query,
    });
  },

  //添加客服
  customerAdd: query => {
    return request({
      url: '/system/customer/saveData',
      method: 'post',
      data: query,
    });
  },

  //更新客服
  updateData: query => {
    return request({
      url: '/system/customer/updateData',
      method: 'post',
      data: query,
    });
  },

  //客服状态更改
  updateStatus: query => {
    return request({
      url: '/system/customer/updateStatus',
      method: 'post',
      data: query,
    });
  },

  //删除客服
  customerDel: query => {
    return request({
      url: '/system/customer/del',
      method: 'post',
      data: query,
    });
  },

  //保存oss配置
  saveAlioss: query => {
    return request({
      url: '/system/config/saveAlioss',
      method: 'post',
      data: query,
    });
  },

  //获取阿里oss配置
  getAlioss: query => {
    return request({
      url: '/system/config/getAlioss',
      method: 'get',
      data: query,
    });
  },
  //获取银行卡列表
  bankList: query => {
    return request({
      url: '/system/bank/list',
      method: 'get',
      params: query,
    });
  },
  //添加银行卡
  addBank: query => {
    return request({
      url: '/system/bank/add',
      method: 'post',
      data: query,
    });
  },
  //编辑银行卡
  editBank: query => {
    return request({
      url: '/system/bank/edit',
      method: 'post',
      data: query,
    });
  },
  //删除银行卡
  delBank: query => {
    return request({
      url: '/system/bank/del',
      method: 'post',
      data: query,
    });
  },
  //更新银行卡状态
  updateBank: query => {
    return request({
      url: '/system/bank/update',
      method: 'post',
      data: query,
    });
  },
  //获收款方式列表
  payableMethodList: query => {
    return request({
      url: '/system/payableMethod/list',
      method: 'get',
      params: query,
    });
  },
  //获收款方式更新状态
  payableMethodUpdate: query => {
    return request({
      url: '/system/payableMethod/update',
      method: 'post',
      data: query,
    });
  },
  //获收款方式修改
  payableMethodEdit: query => {
    return request({
      url: '/system/payableMethod/edit',
      method: 'post',
      data: query,
    });
  },

  // 获取主题列表
  themeList: query => {
    return request({
      url: '/system/theme/list',
      method: 'get',
      params: query,
    });
  },

  // 保存主题配置
  themeSave: query => {
    return request({
      url: '/system/theme/save',
      method: 'post',
      data: query,
    });
  },

  // 获取主题色列表
  themeColorList: query => {
    return request({
      url: '/system/theme/colorList',
      method: 'get',
      params: query,
    });
  },

  // 添加主题色
  themeColorAdd: query => {
    return request({
      url: '/system/theme/colorAdd',
      method: 'post',
      data: query,
    });
  },

  // 编辑主题色
  themeColorEdit: query => {
    return request({
      url: '/system/theme/colorEdit',
      method: 'post',
      data: query,
    });
  },

  // 删除主题色
  themeColorDel: query => {
    return request({
      url: '/system/theme/colorDel',
      method: 'post',
      data: query,
    });
  },

  // 底部菜单列表
  bottomList: query => {
    return request({
      url: '/system/bottom/list',
      method: 'get',
      params: query,
    });
  },

  // 添加菜单
  bottomAdd: query => {
    return request({
      url: '/system/bottom/add',
      method: 'post',
      data: query,
    });
  },

  // 更新状态
  bottomStatus: query => {
    return request({
      url: '/system/bottom/status',
      method: 'post',
      data: query,
    });
  },

  // 删除菜单
  bottomDel: query => {
    return request({
      url: '/system/bottom/del',
      method: 'post',
      data: query,
    });
  },

  // 获取链接页面列表
  bottomLinkList: query => {
    return request({
      url: '/system/bottom/linkList',
      method: 'get',
      params: query,
    });
  },

  // 更新链接与菜单关系
  bottomRelaUpdate: query => {
    return request({
      url: '/system/bottom/relaUpdate',
      method: 'post',
      data: query,
    });
  },

  // 获取菜单详情
  bottomDetails: query => {
    return request({
      url: '/system/bottom/details',
      method: 'get',
      params: query,
    });
  },

  // 编辑菜单
  bottomEdit: query => {
    return request({
      url: '/system/bottom/edit',
      method: 'post',
      data: query,
    });
  },

  // 获取链接分组
  bottomLinkGroup: query => {
    return request({
      url: '/system/bottom/linkGroup',
      method: 'get',
      params: query,
    });
  },

  // 获取链接与菜单关系
  bottomRela: query => {
    return request({
      url: '/system/bottom/bottomRela',
      method: 'get',
      params: query,
    });
  },

  // 生成js菜单文件
  bottomCreateFile: query => {
    return request({
      url: '/system/bottom/createFile',
      method: 'get',
      params: query,
    });
  },

  // 自定义模板预览
  decorateGetQrCodePreview: query => {
    return request({
      url: '/system/decorate/getQrCodePreview',
      method: 'get',
      params: query,
    });
  },

  // 小程序配置列表
  wxminiConfigList: query => {
    return request({
      url: '/system/wxmini/list',
      method: 'get',
      params: query,
    });
  },

  // 数脉-获取身份证ORC配置
  idcardocrgetConfig: query => {
    return request({
      url: '/system/idcardocr/getConfig',
      method: 'get',
      params: query,
    });
  },

  // 数脉-保存身份证ORC配置
  idcardocrsaveConfig: query => {
    return request({
      url: '/system/idcardocr/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 数脉-保存身份证ORC配置
  idcardocrlog: query => {
    return request({
      url: '/system/idcardocr/log',
      method: 'get',
      params: query,
    });
  },

  // 数脉-获取配置
  faceidcardgetConfig: query => {
    return request({
      url: '/system/faceidcard/getConfig',
      method: 'get',
      params: query,
    });
  },

  // 数脉-保存配置
  faceidcardsaveConfig: query => {
    return request({
      url: '/system/faceidcard/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 数脉-人脸比对日志
  faceidcardLog: query => {
    return request({
      url: '/system/faceidcard/log',
      method: 'get',
      params: query,
    });
  },

  // 小程序app列表
  wxminiAppList: query => {
    return request({
      url: '/system/wxmini/appList',
      method: 'get',
      params: query,
    });
  },
  // 小程序配置添加
  wxminiconfigAdd: query => {
    return request({
      url: '/system/wxmini/add',
      method: 'post',
      data: query,
    });
  },
  // 小程序配置编辑
  wxminiconfigEdit: query => {
    return request({
      url: '/system/wxmini/edit',
      method: 'post',
      data: query,
    });
  },
  // 小程序配置删除
  wxminiconfigDelete: query => {
    return request({
      url: '/system/wxmini/del',
      method: 'post',
      data: query,
    });
  },
  //获取二维码
  systemGetQr: query => {
    return request({
      url: '/system/qr/getQr',
      method: 'post',
      data: query,
    });
  },
  // 任务管理列表
  taskList: query => {
    return request({
      url: '/system/task/list',
      method: 'get',
      params: query,
    });
  },
  // 任务管理详情
  taskDetail: query => {
    return request({
      url: '/system/task/detail',
      method: 'get',
      params: query,
    });
  },
  // 任务管理编辑
  taskEditTask: query => {
    return request({
      url: '/system/task/editTask',
      method: 'post',
      data: query,
    });
  },
  // 任务管理状态修改
  taskUpdatestatus: query => {
    return request({
      url: '/system/task/updatestatus',
      method: 'post',
      data: query,
    });
  },
  // 定时任务初始化
  taskTaskInit: query => {
    return request({
      url: '/system/task/taskInit',
      method: 'get',
      params: query,
    });
  },
  // 任务日志
  taskLogList: query => {
    return request({
      url: '/system/task/logList',
      method: 'get',
      params: query,
    });
  },
  // 获取提现配置
  withdrawalGetConfig: query => {
    return request({
      url: '/system/withdrawal/getConfig',
      method: 'get',
      params: query,
    });
  },
  // 更新提现配置
  withdrawalSaveConfig: query => {
    return request({
      url: '/system/withdrawal/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 获取提现记录列表
  withdrawalList: query => {
    return request({
      url: '/system/withdrawal/list',
      method: 'get',
      params: query,
    });
  },
  // 获取提现记录详情
  withdrawalDetails: query => {
    return request({
      url: '/system/withdrawal/details',
      method: 'get',
      params: query,
    });
  },
  // 更新提现记录
  withdrawalUpdate: query => {
    return request({
      url: '/system/withdrawal/update',
      method: 'post',
      data: query,
    });
  },
  //获取零钱明细列表
  getMoneyLog: query => {
    return request({
      url: 'system/money/log',
      method: 'get',
      params: query,
    });
  },
  //获取钱包列表
  getMoneyList: query => {
    return request({
      url: 'system/money/list',
      method: 'get',
      params: query,
    });
  },
  //支付列表
  payTypeList: query => {
    return request({
      url: 'system/payType/list',
      method: 'get',
      params: query,
    });
  },
  // 修改支付配置
  payTypeSave: query => {
    return request({
      url: '/system/payType/save',
      method: 'post',
      data: query,
    });
  },

  // 获取人脸与身份证比对配置
  livingBodyGetConfig: query => {
    return request({
      url: '/system/livingbody/getConfig',
      method: 'get',
      params: query,
    });
  },

  // 保存人脸与身份证比对配置
  livingBodySaveConfig: query => {
    return request({
      url: '/system/livingbody/saveConfig',
      method: 'post',
      data: query,
    });
  },
  // 照片比对日志
  faceComparisonLog: query => {
    return request({
      url: '/system/facecomparison/log',
      method: 'get',
      params: query,
    });
  },
  // 操作日志列表
  operationLogList: query => {
    return request({
      url: '/system/operationLog/list',
      method: 'get',
      params: query,
    });
  },
  // 登录日志
  AccountLogList: query => {
    return request({
      url: '/system/account/getLoginLog',
      method: 'get',
      params: query,
    });
  },
};
